import { axios } from '@/utils/request'
import qs from 'qs'

let moduleName="industrialInfo";

export function selectAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function getIndustrialDataStep(){
  return axios({
    url: `/ws/${moduleName}/getIndustrialDataStep`,
    method: 'get'
  })
}

export function getById(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/getById/${parameter}`,
    method: 'get',
  })
}


export function queryById(id){
  return axios({
    url: `/ws/${moduleName}/${id}`,
    method: 'get'
  })
}


export function listAllByName(name){
  return axios({
    url: `/ws/${moduleName}/listAllByName`,
    method: 'get',
    params:{name:name},
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function saveIndustrial(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/saveIndustrial`,
    method: 'post',
    data:parameter
  })
}


export function updateIndustrial(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/updateIndustrial`,
    method: 'put',
    data:parameter
  })
}

/**
 * 条件查询产业园
 * @param {*} parameter 
 * @returns 
 */
export function selectIndustrialByQuery(parameter){
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectIndustrialByQuery`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}




export default {
  getIndustrialDataStep,
  saveIndustrial,
  updateIndustrial,
  selectAll,
  getById,
  queryById,
  listAllByName
}